<script>
import FormBase from '@/components/FormBase';
import {formulariosHeader} from '@/views/dinacopa/ListaFormulariosAdmin';
import { flattenFields } from '@/components/utils/utils';

export default {
  name: 'EnviarTEESForm',
  extends: FormBase,
  data: () => ({
    idFormulariosField: null,
    versionIdx: 0,
  }),
  methods: {
    onDtoLoaded(dto) {
      this.idFormulariosField = flattenFields(dto.fields).find(d => d.fieldName === 'idFormularios');
    },
    onFormSaved() {
      for (let key of Object.keys(this.formModel)) {
        this.formModel[key] = null;
      }
      // Cambiamos el optionsSource para forzar un reload, para que desaparezcan los códigos TEES que ya no tienen
      // formulario por despachar
      this.idFormulariosField.optionsSource += (!this.idFormulariosField.optionsSource.includes("?") ?  "?"  : '&')
          + 'v=' + (this.versionIdx++);
    },
    getSavePromise(formModel) {
      return this.id
          ? this.$http.put(
              this.updateUrl || `${process.env.VUE_APP_ROOT_API}${this.baseUrl}/${this.id}`,
              formModel,
          )
          : this.$http.post(
              this.createUrl || `${process.env.VUE_APP_ROOT_API}${this.baseUrl}`,
              formModel,
          );
    },
  },
  computed: {
    createUrl() {
      return `${process.env.VUE_APP_ROOT_API}${this.baseUrl}`;
    },
    updateUrl() {
      return `${process.env.VUE_APP_ROOT_API}${this.baseUrl}/${this.id}`;
    },
    headers () {
      return [
        {
          idFormularios: formulariosHeader,
        }];
    },
    confirmTextComp() {
      return 'Los formularios seleccionados serán comunicados al DNA mediante el sistema TEES';
    },
  },
};
</script>

<style scoped>

</style>
